// @flow
import PropTypes from "prop-types";

const MagBadge = ({text, small, danger}) => {
    
    let fontSize = "li-font-medium";
    let bgColor = "li-bg-light";
    if(small) {
        fontSize = "li-font-small";
    }
    
    if(danger) {
        bgColor = "li-bg-danger";
    }
    
    return(
        <div className={"p-2 badge align-middle "+fontSize+ " "+bgColor}>{text}</div>
    );
    
}

MagBadge.propTypes = {
    text: PropTypes.string.isRequired,
    small: PropTypes.bool,
    danger: PropTypes.bool
}

export default MagBadge;